module.exports = __webpack_public_path__ + "img/Payment-Bank.0228b3d9.jpg";